import { UseQueryOptions } from 'react-query';
import { ServiceError } from '../../hooks/error';
import { useCustomQuery } from '../../hooks/query';
import { KeyValueResponse } from '../../api-refactored/typings';
import { GET_ACCOUNT_STATUS_QUERY_KEY } from '../../constants/queryKeys';
import { getAccountStatusList } from '../candidate/account-management/api-services/api';

interface GetAccountStatusQueryProps {
  isCandidate: boolean;
  queryOptions?: UseQueryOptions<KeyValueResponse[], ServiceError>;
}

/** to get account status
 * @returns KeyValueResponse[]
 * */
export const useGetAccountStatusQuery = ({ isCandidate, queryOptions }: GetAccountStatusQueryProps) =>
  useCustomQuery<KeyValueResponse[]>(
    GET_ACCOUNT_STATUS_QUERY_KEY,
    () => getAccountStatusList(isCandidate).then((res) => res.data),
    queryOptions,
    false,
    false
  );
